import { FC } from 'react'
import { FormSearchArtist } from '../SearchArtist'
import { FormSearchProduct } from '../SearchProduct'
import { FormAdvertiserSelect } from '../SearchAdvertiser'
import { FormMediaBuyerSelect } from '../SearchMediaBuyer'
import { InfoField } from '../InfoField'

export const ReleaseGenerateCampaignForm: FC = () => (
  <>
    <FormAdvertiserSelect />
    <FormMediaBuyerSelect />
    <FormSearchArtist isRequired />
    <FormSearchProduct />
    <InfoField />
  </>
)
